import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'groupBy'
})
export class GroupByPipe implements PipeTransform {
  transform(value: any[], key: string): any[] {
    const groupedObj = value.reduce((acc, obj) => {
      const groupKey = obj[key];
      acc[groupKey] = acc[groupKey] || [];
      acc[groupKey].push(obj);
      return acc;
    }, {});

    return Object.keys(groupedObj).map(key => ({
      operationType: key,
      items: groupedObj[key]
    }));
  }
}
